import React from 'react'
import { useNavigate } from 'react-router-dom'
import { HeaderWithBack } from '@ui/components'

import { ReactComponent as BackIcon } from '@/assets/icons/back_icon.svg'

export const HeaderWithBackAena = ({ title, navigateTo }: { title: string; navigateTo?: string }) => {
  const navigate = useNavigate()

  const handleBackPress = () => {
    if (navigateTo) {
      navigate(navigateTo)
    } else {
      navigate(-1)
    }
  }

  return <HeaderWithBack title={title} backPress={handleBackPress} backIcon={<BackIcon />} />

}
